import { Component, Input, OnInit } from '@angular/core';
import { CurrentUserService } from '@shared/services/current-user.service';
import { SnackbarService } from '@shared/services/snackbar.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  @Input() userId: number;
  resetPasswordStep = 1;
  newPassword: string;
  showResetConfirmation: boolean;

  constructor(
    private snackbarService: SnackbarService,
    private currentUserService: CurrentUserService,
  ) { }

  ngOnInit(): void {
  }

  resetPasswordClick() {
    this.showResetConfirmation = true;
  }

  resetPassword() {
    ++this.resetPasswordStep;
    this.showResetConfirmation = false;
    this.currentUserService.resetPassword(this.userId).subscribe({
      next: password => {
        this.newPassword = password;
        ++this.resetPasswordStep;
      },
      error: () => --this.resetPasswordStep
    });
  }

  passwordCopied() {
    this.snackbarService.showMessage($localize`Пароль скопирован`);
  }
}
